const state = {
  menuData: []
}

const mutations = {
  SET_MENU: (state, menuData) => {
    state.menuData = menuData
  }
}

const actions = {
  setMenu({ commit }, menuData) {
    commit('SET_MENU', menuData)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}